import { createContext, useContext } from "react";
import * as marketing from "@alm/domain/marketing/site-version";

export type SiteVersion = marketing.SiteVersion;

// File routes have no base path, so the arm is a context and `MLink` adds its prefix.
export const SiteVersionContext = createContext<SiteVersion | null>(null);

function useSiteVersion(): SiteVersion | null {
  return useContext(SiteVersionContext);
}

export function useSiteBase(): string {
  const version = useSiteVersion();
  return version ? `/${version}` : "";
}
